/**
 * DEV ONLY. Purchases are granted by the API's dev route (IAP_DEV=1), with the
 * same idempotency, daily-spend and COPPA checks as real receipts.
 */
import { ROUTES, type ApiClient } from '../api.js';
import { randomId } from '../lazy.js';
import type { DevPurchase, PurchaseResponse, StoreResponse } from '../schemas.js';
import { confirmFlag, fromResponse, withUsdPrice, type IapProduct, type IapProvider, type PurchaseOptions, type PurchaseResult } from './types.js';

export class DevIapProvider implements IapProvider {
  readonly provider = 'dev';

  constructor(
    private readonly api: ApiClient,
    private readonly newKey: () => string = randomId,
  ) {}

  async products(): Promise<IapProduct[]> {
    const store = await this.api.call<StoreResponse>('GET', ROUTES.store);
    return store.products.map(withUsdPrice);
  }

  async purchase(productId: string, opts: PurchaseOptions = {}): Promise<PurchaseResult> {
    const idemKey = this.newKey();
    const body: DevPurchase = { productId, idemKey, ...confirmFlag(opts) };
    const res = await this.api.call<PurchaseResponse>('POST', ROUTES.purchaseDev, body);
    return fromResponse('dev', productId, res, `dev:${idemKey}`);
  }

  /** Dev grants live on the server; the next snapshot already carries them. */
  async restore(): Promise<PurchaseResult[]> {
    return [];
  }

  async resume(): Promise<PurchaseResult | null> {
    return null;
  }
}
